export default __webpack_public_path__ + "static/media/gallery_33.b396c418.jpg";